























































































































import {
    linking
} from '@/mla-shared';
import store from '../store'

export default {
    data() {
        return {
            title: 'Help'
        }
    },
    store,

    methods: {
        openLink: function (evt) {
            evt.preventDefault();
            linking({
                operation: 'openURL',
                openURL: evt.target.href
            });
        }
    }
}
